import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const TableView = ({ data, onSelectTerm }) => {
  if (data.length === 0) {
    return <div className="text-xl font-bold p-8 text-center border-4 border-black border-dashed">NO TERMS FOUND.</div>;
  }

  return (
    <div className="overflow-x-auto border-2 border-black bg-white shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]">
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="bg-black text-white uppercase text-base">
            <th className="p-3 border-r-2 border-black whitespace-nowrap">Term</th>
            <th className="p-3 border-r-2 border-black">Category</th>
            <th className="p-3 border-r-2 border-black">Plain English</th>
            <th className="p-3 border-r-2 border-black whitespace-nowrap">Tags</th>
            <th className="p-3 whitespace-nowrap font-mono">Date</th>
            <th className="p-3 whitespace-nowrap text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr 
              key={item.id} 
              className={`
                border-t-2 border-black text-base
                hover:bg-gray-50 transition-colors cursor-pointer
              `}
              style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa' }}
              onClick={() => onSelectTerm(item)}
            >
              <td className="p-3 border-r-2 border-black font-bold text-lg whitespace-nowrap">
                <div className="flex items-center gap-2">
                  <div className="w-3 h-3 border-2 border-black" style={{ backgroundColor: item.color }}></div>
                  {item.term}
                </div>
              </td>
              <td className="p-3 border-r-2 border-black font-medium whitespace-nowrap">
                {item.category}
              </td>
              <td className="p-3 border-r-2 border-black max-w-xs truncate">
                {item.plainEnglish}
              </td>
              <td className="p-3 border-r-2 border-black">
                <div className="flex flex-wrap gap-1">
                  {item.keyTerms.slice(0, 2).map((tag, idx) => (
                    <span key={idx} className="bg-black text-white text-[10px] px-1.5 py-0.5 font-bold uppercase">
                      {tag}
                    </span>
                  ))}
                </div>
              </td>
              <td className="p-3 border-r-2 border-black font-mono font-bold whitespace-nowrap">
                 {new Date(item.dateAdded).toLocaleDateString()}
              </td>
              <td className="p-3 text-center">
                 <button className="bg-white border-2 border-black p-1.5 hover:bg-black hover:text-white transition-colors">
                    <SafeIcon icon={FiIcons.FiMaximize2} className="text-sm" />
                 </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableView;